import type { LeaveTypesRepositoryT } from "../../domain/ports/leaveTypes.repository";
import type { CreateLeaveTypeFormValuesT } from "../../domain/types/leaveType.types";

type CreateLeaveTypeParamsT = {
  leaveTypesRepository: LeaveTypesRepositoryT;
  data: CreateLeaveTypeFormValuesT;
  colaboraInstanceId: string;
};

export const createLeaveType = async ({
  leaveTypesRepository,
  data,
  colaboraInstanceId,
}: CreateLeaveTypeParamsT) => {
  return await leaveTypesRepository.create(data, colaboraInstanceId);
};
